import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginatorState, PageSizes } from '../../models/paginator.model';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
})
export class PaginatorComponent implements OnInit {
  @Input() paginator: PaginatorState;
  @Input() isLoading:any;
  @Input() shouldPaginate:any;
  @Input() pageNumber:any;
  @Output() paginate: EventEmitter<PaginatorState> = new EventEmitter();
  pageSizes: number[] = PageSizes;
  constructor() {}

  ngOnInit(): void {
  }


  pageChange(num: number) {
    if(this.shouldPaginate){
      this.paginator.page = this.pageNumber;
    }
    else{
      this.paginator.page = num;
    }
    this.paginate.emit(this.paginator);
  }

  sizeChange() {
    this.paginator.pageSize = +this.paginator.pageSize;
    this.paginator.page = 1;
    this.paginate.emit(this.paginator);
  }
  changeshouldPaginate(){
    this.shouldPaginate =false
  }
}
